import './styles/Spinner.scss';
import { useState, useRef, useEffect } from 'react';

//classes
class Coordinate {
    x: number = 0; y: number = 0;
}

interface Props {
    size: number //in px, applies to width and height of spinner
    interval: number, //in millis cycles interval, lower this number faster the spinner animation
    colorTheme: string[] //hex colors to beautify the spinner
}

const Spinner: React.FC<Props> = ({ size, interval, colorTheme }) => {
    //states
    const [shouldShowSpinner, SetShouldShowSpinner] = useState(false);
    const [rotation, SetRotation] = useState(0);
    const [dot1Anim, SetDot1Anim] = useState('hide');
    const [dot2Anim, SetDot2Anim] = useState('hide');
    const [dot3Anim, SetDot3Anim] = useState('hide');
    const [dot1Coord, SetDot1Coord] = useState<Coordinate>({ x: 0, y: 0 } as Coordinate);
    const [dot2Coord, SetDot2Coord] = useState<Coordinate>({ x: 0, y: 0 } as Coordinate);
    const [dot3Coord, SetDot3Coord] = useState<Coordinate>({ x: 0, y: 0 } as Coordinate);
    //refs
    const rotateIntervalRef = useRef<any>(null);
    const rotationRef = useRef<number>(rotation);

    //watchers
    //test
    // useEffect(() => {
    //     console.log('SpinnerTest: ' + JSON.stringify(dot2Coord));
    // }, [dot2Coord]);

    //initialize
    useEffect(() => {
        Reanimate();
        setTimeout(() => {
            SetShouldShowSpinner(true);
        }, 500);

        return (() => {
            if (rotateIntervalRef.current != null) {
                clearInterval(rotateIntervalRef.current);
                rotateIntervalRef.current = null;
            }
            SetShouldShowSpinner(false);
        });
    }, []);

    //watch for size change update dots coordinates
    useEffect(() => {
        SetDot1Coord(GetCoordinateByDegree(size * .9, 210));
        SetDot2Coord(GetCoordinateByDegree(size * .9, 225));
        SetDot3Coord(GetCoordinateByDegree(size * .9, 240));
    }, [size]);

    //watch for interval change restart animation interval
    useEffect(() => {
        if (rotateIntervalRef.current != null) {
            clearInterval(rotateIntervalRef.current);
            rotateIntervalRef.current = null;
        }

        rotateIntervalRef.current = setInterval(() => {
            Reanimate();
        }, interval);
    }, [interval]);

    //exe functions
    const Reanimate = () => {
        //iniialize hide all dots
        setTimeout(() => {
            SetDot1Anim('hide');
            SetDot2Anim('hide');
            SetDot3Anim('hide');
        }, 100);

        rotationRef.current += 360;
        SetRotation(rotationRef.current);

        const spinInterval = interval * .5;
        const dotInterval = (interval * .4) / 3;

        //show dots after delays
        setTimeout(() => {
            SetDot1Anim('show');
        }, spinInterval + (dotInterval * 1));
        setTimeout(() => {
            SetDot2Anim('show');
        }, spinInterval + (dotInterval * 2));
        setTimeout(() => {
            SetDot3Anim('show');
        }, spinInterval + (dotInterval * 3));
    };
    const GetCoordinateByDegree = (_size: number, degree: number) => {
        const radian = degree * (Math.PI / 180);
        const x = _size / 2 + _size / 2 * Math.cos(radian);
        const y = _size / 2 + _size / 2 * Math.sin(radian);

        return { x: x, y: y } as Coordinate;
    };

    return (
        <div className={'Spinner ' + (shouldShowSpinner ? 'show' : 'hide')} style={{ width: `${size}px`, height: `${size}px`, transform: `rotateZ(${rotation}deg)`, transition: `transform ${(interval * .5) / 1000}s ease-in-out` }}>
            <div className={'Spinner-outer-border '} style={{ border: `${size * .1}px solid ${colorTheme[0]}` }} />
            <div className={'Spinner-dot _1 ' + dot1Anim} style={{ width: `${size * .1}px`, height: `${size * .1}px`, backgroundColor: `${colorTheme.length > 1 ? colorTheme[1] : colorTheme[0]}`, left: `${dot1Coord.x}px`, top: `${dot1Coord.y}px`, transition: `opacity ${((interval * .4) / 3) / 1000}s ease-in-out` }} />
            <div className={'Spinner-dot _2 ' + dot2Anim} style={{ width: `${size * .1}px`, height: `${size * .1}px`, backgroundColor: `${colorTheme.length > 2 ? colorTheme[2] : colorTheme[0]}`, left: `${dot2Coord.x}px`, top: `${dot2Coord.y}px`, transition: `opacity ${((interval * .4) / 3) / 1000}s ease-in-out` }} />
            <div className={'Spinner-dot _3 ' + dot3Anim} style={{ width: `${size * .1}px`, height: `${size * .1}px`, backgroundColor: `${colorTheme.length > 3 ? colorTheme[3] : colorTheme[0]}`, left: `${dot3Coord.x}px`, top: `${dot3Coord.y}px`, transition: `opacity ${((interval * .4) / 3) / 1000}s ease-in-out` }} />
        </div>
    );
}
export default Spinner;